import elementoVisivel from '../dom';

const CRIAR = '[data-tour="licitacoes-criar"]';

export default {
  id: 'licitacoes-criar',
  kind: 'tour',
  version: 2,
  label: 'Criar licitação',
  contexts: ['licitacoes.lista'],
  scopes: ['criar'],
  priority: 20,
  // Sem FeatureTourHelp para o scope "criar" — não há ícone "?" para reabrir manualmente.
  help: false,
  canQueue(ctx = {}) {
    return Boolean(ctx.logged && ctx.canCreate);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.canCreate) return false;
    return Boolean(elementoVisivel(CRIAR));
  },
  steps() {
    return [
      {
        element: CRIAR,
        popover: {
          title: 'Criar licitação',
          description:
            'Abra o menu para iniciar um pregão, uma concorrência ou uma dispensa, de acordo com as permissões do seu usuário.',
          side: 'bottom',
          align: 'end',
        },
      },
    ];
  },
};
